import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsEquipmentInstanceStatus, PmsEquipmentInstanceStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsEquipmentInstanceStatus>
    useData={usePmsEquipmentInstanceStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
